"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var StyledSwitch = (0, core_1.styled)(function (props) { return react_1.default.createElement(core_1.Switch, __assign({ disableRipple: true }, props)); })(function (_a) {
    var theme = _a.theme;
    return ({
        width: 50,
        height: 30,
        padding: 2,
        '& .MuiSwitch-switchBase': {
            padding: 3,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(20px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#007983',
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible + .MuiSwitch-track': {
                outline: "1px solid black !important",
                outlineOffset: 1
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 20,
            height: 20,
            boxShadow: '0px 0px 4px -1px rgba(0, 0, 0, 0.5);'
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#637381',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        }
    });
});
exports.default = StyledSwitch;
//# sourceMappingURL=SwitchWithStyle.js.map